'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useEffect, useRef } from 'react';

type Props = {
  scriptUrl: string;
  className?: string;
  minHeight?: string;
  title?: string;
};

function AgencyReviewsWidget({ scriptUrl, className, minHeight = '120px', title = 'Google reviews' }: Props) {
  const reviewsFrameRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const frame = reviewsFrameRef.current;
    if (!frame) return;

    const iframeDocument = frame.contentDocument || frame.contentWindow?.document;
    if (!iframeDocument) return;

    iframeDocument.open();
    iframeDocument.write(`<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <style>
      html, body { margin: 0; padding: 0; background: transparent; overflow: hidden; }
      .review-footer-title { display: none !important; }
      .partner-reviews { color: #343a40 !important; border-bottom: 1px solid; }
      .yext-reviews .review-footer { margin: 0!important; }
      .yext-reviews .review-footer .review-footer-content { margin-top: 0!important; }
    </style>
  </head>
  <body>
    <script type="text/javascript" src="${scriptUrl}"><\/script>
  </body>
</html>`);
    iframeDocument.close();

    let attempts = 0;
    const resizeInterval = window.setInterval(() => {
      const contentHeight = iframeDocument.body?.scrollHeight || 0;
      if (contentHeight > 0) frame.style.height = `${contentHeight}px`;
      attempts += 1;
      if (attempts >= 30) window.clearInterval(resizeInterval);
    }, 250);

    return () => window.clearInterval(resizeInterval);
  }, [scriptUrl]);

  return <iframe ref={reviewsFrameRef} title={title} className={className} style={{ minHeight }} />;
}

export default AgencyReviewsWidget;
